// extracted by mini-css-extract-plugin
export default {"Signin":"SignIn_Signin__pudSz","alignVerticalCenter":"SignIn_alignVerticalCenter__UCSJB","signinWrapper":"SignIn_signinWrapper__QtHNL","subtitle":"SignIn_subtitle__-9no8"};